import { PKCEAuth } from '../utils/pkceAuth';
import store from '../store/store';
import { AUTH_ACTIONS } from '../store/reducers/auth';


interface AuthProps {
  auth?: {
    user?: {
      access_token?: string;
    };
  };
}

class AuthService {

  
  static login = (): void => {
    // Dispatch login request action to show loading state
    store.dispatch({ type: AUTH_ACTIONS.LOGIN_REQUEST });

    PKCEAuth.saveCurrentPage();
    PKCEAuth.initiateLogin();
  };

  static signOutRedirect = async (token?: string): Promise<void> => {
    try {
      await PKCEAuth.revokeTokens();
     
      await PKCEAuth.logout(token);
      sessionStorage.removeItem('isProductFirstHovered');
        
    } catch (error) {
      console.error('Error during sign out:', error);
    }
  };

  static signinRedirectCallback = async (): Promise<any> => {
    try {
      store.dispatch({ type: AUTH_ACTIONS.LOGIN_REQUEST });
      const user = await PKCEAuth.handleCallback();
      store.dispatch({ type: AUTH_ACTIONS.LOGIN_SUCCESS, payload: user });
      return user;
    } catch (error) {
      console.error('Error during sign in callback:', error);
      store.dispatch({ type: AUTH_ACTIONS.LOGIN_FAILURE, payload: error });
      throw error;
    }
  };

  static isAuthenticated = (props: AuthProps): boolean => {
    return !!props?.auth?.user?.access_token;
  };

  static clearError = (): void => {
    store.dispatch({ type: AUTH_ACTIONS.CLEAR_ERROR });
  };
}

export default AuthService;
